import React, { useMemo } from "react";

const project = (lat, lng, bounds) => {
  const x = ((lng - bounds.minLng) / (bounds.maxLng - bounds.minLng)) * 100;
  const y = (1 - (lat - bounds.minLat) / (bounds.maxLat - bounds.minLat)) * 100;
  return { x: Math.max(4, Math.min(96, x)), y: Math.max(6, Math.min(94, y)) };
};

const OperationMap = ({ operation, selectedRouteId, onSelectRoute }) => {
  const bounds = useMemo(() => {
    const points = [];
    (operation?.schools || []).forEach((school) => points.push([school.lat, school.lng]));
    (operation?.students || []).forEach((student) => {
      if (student.lat != null) points.push([student.lat, student.lng]);
    });
    if (points.length === 0) {
      return { minLat: 30.2, maxLat: 30.33, minLng: -97.87, maxLng: -97.72 };
    }
    const lats = points.map((p) => p[0]);
    const lngs = points.map((p) => p[1]);
    const padLat = 0.01;
    const padLng = 0.015;
    return {
      minLat: Math.min(...lats) - padLat,
      maxLat: Math.max(...lats) + padLat,
      minLng: Math.min(...lngs) - padLng,
      maxLng: Math.max(...lngs) + padLng,
    };
  }, [operation]);

  if (!operation?.routes?.length) return null;

  return (
    <div className="start-map" role="img" aria-label="Demonstration map of sample school routes">
      <svg viewBox="0 0 100 100" preserveAspectRatio="none">
        {[18, 36, 54, 72, 90].map((y) => (
          <line key={`h-${y}`} x1="0" y1={y} x2="100" y2={y} className="start-map__grid" />
        ))}
        {[12, 28, 44, 60, 76, 92].map((x) => (
          <line key={`v-${x}`} x1={x} y1="0" x2={x} y2="100" className="start-map__grid" />
        ))}
        {operation.routes.map((route) => {
          const pts = route.stops
            .filter((stop) => stop.lat != null)
            .map((stop) => project(stop.lat, stop.lng, bounds));
          if (pts.length < 2) return null;
          const d = pts.map((pt, index) => `${index === 0 ? "M" : "L"} ${pt.x} ${pt.y}`).join(" ");
          const active = route.id === selectedRouteId;
          return (
            <path
              key={route.id}
              d={d}
              fill="none"
              stroke={route.color}
              strokeWidth={active ? 1.8 : 0.9}
              opacity={active ? 1 : 0.35}
              className="start-map__route"
            />
          );
        })}
        {(operation.students || [])
          .filter((student) => student.lat != null)
          .map((student) => {
            const pt = project(student.lat, student.lng, bounds);
            return <circle key={student.id} cx={pt.x} cy={pt.y} r="0.7" fill="#cbd5e1" opacity="0.7" />;
          })}
        {operation.schools.map((school) => {
          const pt = project(school.lat, school.lng, bounds);
          return (
            <g key={school.id}>
              <circle cx={pt.x} cy={pt.y} r="2.4" fill={school.color} />
              <text x={pt.x + 3} y={pt.y + 1} className="start-map__label">
                {school.name.split(" ")[0]}
              </text>
            </g>
          );
        })}
      </svg>
      <ul className="start-map__legend">
        {operation.routes.map((route) => (
          <li key={route.id}>
            <button
              type="button"
              className={route.id === selectedRouteId ? "is-active" : ""}
              onClick={() => onSelectRoute(route.id)}
            >
              <i style={{ background: route.color }} />
              {route.name}
              <span>
                {route.students.length} students · {route.vehicle}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default OperationMap;
